import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes.ts'

import mapBg from 'shared/images/map-bg.png'
import { ImageLazy } from 'shared/ui/image-lazy'
import { Loader } from 'shared/ui/loader'
import { ErrorMap } from 'shared/ui/map/components'
import { useMap } from 'shared/ui/map/libs'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface HotelMapProps {
  hotelName: string
  latitude: number
  longitude: number
  title?: string
}

export const MiniMap = ({
  hotelName,
  latitude,
  longitude,
  title,
}: HotelMapProps) => {
  const navigate = useNavigate()

  const { isMapLoading, mapError, mapRef, handleRetry } = useMap({
    center: { latitude, longitude },
    markers: [{ latitude, longitude, title: hotelName }],
    disableZoom: true,
  })

  const handleOpenFullMap = () => {
    navigate(RoutingPaths.tours.hotelMap.path(), {
      state: { hotelName, latitude, longitude },
    })
  }

  return (
    <Paper
      className={s.container}
      padding={[12, 14, 14, 14]}
    >
      {title && <p className={clsx('semi-bold-16', s.title)}>{title}</p>}

      <div
        className={s.mapWrapper}
        onClick={handleOpenFullMap}
      >
        <div
          className={s.map}
          ref={mapRef}
        />

        {isMapLoading && (
          <div className={s.loadingOverlay}>
            <ImageLazy
              src={mapBg}
              className={s.mapBg}
            />
            <Loader />
          </div>
        )}

        {mapError && (
          <ErrorMap
            error={mapError}
            onTryAgain={handleRetry}
          />
        )}
      </div>
    </Paper>
  )
}
